import { render } from "./Step1Assess.vue?vue&type=template&id=7f5c027e"
import script from "./Step1Assess.vue?vue&type=script&lang=js"
export * from "./Step1Assess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__